import { useTranslation } from 'react-i18next'
import { RequestMeetingInviteButton } from '../../../meeting/invite/RequestMeetingInviteButton'
import PerFlexRow from '../../../../components/custom_components/FlexRow'

export const RequestMeetingTile = (): JSX.Element => {
  const [t] = useTranslation()

  return (
    <>
      <PerFlexRow align="middle" className="meetingTile" mt="xs" mb="xxs">
        {t('dashboard.employee.meetings.employeeRequestMeetingText')}
      </PerFlexRow>
      <PerFlexRow align="bottom" className="meetingTile" justify="center">
        <RequestMeetingInviteButton pastel btnSize="small" fullWidth context="MyMeetings" />
      </PerFlexRow>
    </>
  )
}
